import { getDictionary } from 'lib/api/queries/dictionary/getDictionary';
import { getCache, getCacheKey, setCache } from 'lib/cache';
import { logInfo, logWarn } from 'lib/utilities/logger';
import { extractContent, validateLanguage } from '../language';
import labelsBooking from './dictionaries/en.booking.json';
import labelsItinerary from './dictionaries/en.itinerary.json';

const getCruiseSearchDictionary = async (languageCode, config, logId) => {
	try {
		const result = await getDictionary(config.dictionaries.cruiseSearchClient, languageCode, config);
		const { error = null } = result;

		return error ? labelsItinerary : { ...labelsItinerary, ...result };
	} catch (error) {
		logWarn('Error loading dictionary, using fallback', { error, logId });

		return labelsItinerary;
	}
};

const getBookingDictionary = async (languageCode, config, logId) => {
	try {
		const newLabels = await getDictionary(config.dictionaries.booking, languageCode, config);
		const newErrorLabels = await getDictionary(config.dictionaries.bookingErrors, languageCode, config);
		const error = newLabels?.error || newErrorLabels?.error || null;

		return error ? labelsBooking : { ...labelsBooking, ...newLabels, ...newErrorLabels };
	} catch (error) {
		logWarn('Error loading booking dictionary, using fallback', { error, logId });

		return labelsBooking;
	}
};

export const loadDictionaries = async (languageCode, config, logId) => {
	const cacheKey = getCacheKey('dictionary', [languageCode]);
	const cachedData = getCache(cacheKey);

	if (cachedData) {
		logInfo('[Server Cache] Dictionary Cache Hit', { cacheKey, logId });
		return cachedData;
	}

	logInfo('[Server Cache] Dictionary Cache Miss', { cacheKey, logId });

	const cruiseSearchDictionary = await getCruiseSearchDictionary(languageCode, config, logId);
	const bookingDictionary = await getBookingDictionary(languageCode, config, logId);
	const dictionaries = { cruiseSearchDictionary, bookingDictionary };

	if (validateLanguage(languageCode, extractContent(dictionaries), logId)) {
		setCache(cacheKey, dictionaries);
	}

	return dictionaries;
};
